import React, { useState, useEffect, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";

export default function AutocompleteWithPagination({
  value,
  onChange,
  getData,
  name,
  limit,
  label,
  fieldName = "name",
}) {
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const listRef = useRef(null);

  const loadData = async (reset = false) => {
    if (loading) return;

    setLoading(true);

    const currentPage = reset ? 1 : page;

    let items = await getData(name, page, search);

    setOptions((prev) => (reset ? items : [...prev, ...items]));

    setHasMore(items.length === limit);
    setPage(currentPage + 1);
    setLoading(false);
  };

  // Load first page
  useEffect(() => {
    loadData(true);
  }, [search]);

  // Infinite scroll handler
  const handleScroll = (event) => {
    const bottom =
      event.target.scrollTop + event.target.clientHeight >=
      event.target.scrollHeight - 10;
    // (limit <= 20 ? 10 : limit <= 50 ? 30 : 50);

    if (bottom && hasMore && !loading) {
      loadData(false);
    }
  };

  return (
    <Autocomplete
      value={value}
      onChange={(e, val) => onChange(val)}
      options={options}
      getOptionLabel={(option) => option[fieldName] || ""}
      onInputChange={(e, value) => {
        setSearch(value);
        setPage(1);
        setHasMore(true);
      }}
      isOptionEqualToValue={(option, val) => {
        return option.id === val.id;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={option.id} {...otherProps}>
            {option[fieldName]}
          </li>
        );
      }}
      ListboxProps={{
        onScroll: handleScroll,
        ref: listRef,
        style: { maxHeight: 300, overflow: "auto" },
      }}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
